<template>
    <div class="text-a-brown-502314" v-if="isLoaded">
        <div class="py-2 font-bold">{{lbl.deliverymethod.select_time}}</div>
        <div @click="clickSelect('now')" 
            class="bg-white flex p-2 rounded-10 cursor-pointer"
            :class="{'border border-a-brown-502314':selectDelivery.type == 'now'}">
            <img class="ml-0 mr-2" src="@/assets/icon/ic-schedule-brown.svg"/>
            <div class="ml-0 mr-auto" v-if="delivery.deliveryMethod == 'Delivery'">{{lbl.deliverymethod.now}} {{lbl.deliverymethod.wait_cooked}}</div>
            <div class="ml-0 mr-auto" v-else>{{lbl.deliverymethod.now}}</div> 
            <img class="mr-0 ml-auto" v-if="selectDelivery.type == 'now'" src="@/assets/icon/ic-check-brown.svg" />
        </div>
        <!-- <div v-show="delivery.deliveryMethod == 'InStore'"  -->
        <div v-show="isShowSpecific"
            class="bg-white p-2 rounded-10 mt-3 cursor-pointer"
            :class="{'border border-a-brown-502314':selectDelivery.type == 'specific'}">
            <div class="flex" @click="clickSelect('specific')" 
                :class="{'border-b border-a-brown-d7c7b8 pb-3':selectDelivery.type == 'specific'}">
                <img class="ml-0 mr-2" src="@/assets/icon/ic-calendar-brown.svg"/>
                <div class="ml-0 mr-auto" >{{lbl.deliverymethod.at_specific_time}}</div>
                <img class="mr-0 ml-auto" v-if="selectDelivery.type == 'specific'" src="@/assets/icon/ic-check-brown.svg" />
            </div>
            <InputCalendar
                v-if="selectDelivery.type == 'specific' && isInitialTime"
                class="mt-3"
                v-model:inputValue="timeDelivery.date"
                :lowerLimit="currentDate"
                :upperLimit="upperLimitDate"
                @onDateChange="onDateChange($event)"
            ></InputCalendar>
        </div>
    </div>
</template>

<script>
import DatetimeHelper from '@/helper/DatetimeHelper';
import InputCalendar from "@/components/Input/simple/InputCalendar.vue"
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "SelectTime",
    mixins: [LocaleMixin],
    inject: ['DeliveryStore'],
    props: {
        isShowSpecific: { type: Boolean, default: false },
        delivery: { type: Object},
        limitDate: { type: Number }
    },
    components:{
        InputCalendar
    },
    data: function() {
        return {
            isInitialTime: false,
            timeDelivery: {
                date: null
            },
            selectDelivery: {
                type: "now"
            },
            currentDate: new Date(),
            upperLimitDate: new Date(),
            isLoaded: false
        }
    },
    created: function() {
        this.initDate();
        if (this.DeliveryStore.state.delivery.deliverTime) {
            this.validateInitDate();
            this.selectDelivery.type = 'specific';
        }

        this.isInitialTime = true;
        
    },
    methods: {
        initDate: function() {
            // this.currentDate.setDate(this.currentDate.getDate() + 1);
            this.upperLimitDate.setDate(this.upperLimitDate.getDate() + (this.limitDate > 0 ? this.limitDate - 1 : 0));
            this.isLoaded = true;
        },
        validateInitDate: function () { 
            let deliverTime = DatetimeHelper.unixTimestampToDate(this.DeliveryStore.state.delivery.deliverTime)
            let minute = DatetimeHelper.compareDetaTimePickup(this.currentDate,deliverTime);
           
            if (minute < 60) {
                this.currentDate = DatetimeHelper.getDateTimeAddMinute(this.currentDate,60);
                let currentDateNew = DatetimeHelper.getDateTimeToTimeStampPickup(this.currentDate);
                let startDate = DatetimeHelper.convertDateToTimeStampUnix(currentDateNew);
                
                this.timeDelivery.date = startDate;
                this.DeliveryStore.state.delivery.deliverTime = startDate;
            } else {
                this.timeDelivery.date = this.DeliveryStore.state.delivery.deliverTime;
            }
        },
        clickSelect: function (timeType) {
            this.selectDelivery.type = timeType;
            if (this.selectDelivery.type == "now") {
                this.DeliveryStore.state.delivery.deliverTime = null;
            } else {
                let value = {
                    date: new Date()
                }
                this.validateDate(value)
            }
        },
        onDateChange: function(value) {
            this.validateDate(value)
        },

        validateDate: function(value) {
            this.currentDate = new Date();
            // this.currentDate.setDate(this.currentDate.getDate() + 1);
            console.log('currentDate', this.currentDate);
            console.log('value.date',value.date);
            let minute = DatetimeHelper.compareDetaTimePickup(this.currentDate,value.date);
            console.log('minute',minute);
            let dtNew = null;
            if (minute < 60) {
                this.currentDate = DatetimeHelper.getDateTimeAddMinute(this.currentDate,60);
                console.log('currentDate new',this.currentDate);
                dtNew = DatetimeHelper.getDateTimeToTimeStampPickup(this.currentDate);
            } else {
                dtNew = DatetimeHelper.getDateTimeToTimeStampPickup(value.date);
            }

            this.isInitialTime = false;
            
            this.$nextTick(() => {
                if (dtNew) {
                    let timeStampNew = DatetimeHelper.convertDateToTimeStampUnix(dtNew);
                    this.timeDelivery.date = timeStampNew;
                    value.timestamp = timeStampNew;
                }
                this.DeliveryStore.state.delivery.deliverTime = value.timestamp;
                this.isInitialTime = true;
            });
        }
        
    }
}
</script>

<style lang="scss" scoped>

</style>